(function($){
    $(document).ready(function() {

        //START add isotope filter on archive ristoranti
        var $shop = $('.archive-ristornati-wrapper .isotope-wrapper').isotope({
            itemSelector: '.col',
            layoutMode: 'fitRows'
        });

        $shop.isotope({ filter: '*' });

        $('.archive-ristornati-wrapper .terms .term').on('click', function() {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $shop.isotope({ filter: '*' });
            } else {
                $('.archive-ristornati-wrapper .terms .term').removeClass('active');
                var filterValue = $(this).attr('data-filter');
                if (filterValue) {
                    var dotfilterValue = filterValue;
                    $(this).addClass('active');
                    $shop.isotope({ filter: dotfilterValue });
                } else {
                    $shop.isotope({ filter: '*' });
                }
            }
        });
        //STOP add isotope filter on archive ristoranti

    });
})
(jQuery);
